export enum LayoutType {
    Grid = 'grid',
    List = 'lijst',
    Dambord = 'dambord'
}
